import packagejson from './package.json';
import config from '@/config.json';

console.log(`${packagejson.description} v${packagejson.version} is starting...`);

if (!config) {
  console.error('No config found');
} else {
  console.log('Config found');
  console.debug(Object.keys(config), { depth: null });
}

import('./src/bootstrap');
